/* eslint-disable */
// @ts-nocheck
import React from "react";
import { ComposedModal, ModalHeader, ModalBody } from "@carbon/react";
import { ReactComponent as BarChart } from "../../assets/icons/barchart.svg";
import BarCharts from "../charts/BarCharts";

interface IProps {
  modalHeaderText: string;
  modalSubHeaderText?: string;
  chartData: any;
  chartOptions: any;
  open: boolean;
  setOpen: (active: boolean) => void;
  preventCloseOnClickOutside?: boolean;
}

const ChartModal = ({
  modalHeaderText,
  modalSubHeaderText,
  chartData,
  chartOptions,
  open,
  setOpen,
  preventCloseOnClickOutside = true,
}: IProps) => {
  const handleKeyPress = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      if (open) {
        setOpen(false);
      }
    }
  };

  return (
    <div className="chart-modal-container">
      <ComposedModal
        className="modal-content"
        size="sm"
        open={open}
        setOpen={setOpen}
        onKeyDown={handleKeyPress}
        preventCloseOnClickOutside={preventCloseOnClickOutside}
        selectorPrimaryFocus={".w-full"}
      >
        <ModalHeader
          buttonOnClick={() => {
            setOpen(false);
          }}
          className="chart-modal-header-contanier"
        >
          <h4 className="chart-modal-header">
            <span className="chart-modal-icon">
              <BarChart />
            </span>
            <p className="modal-header-text">{modalHeaderText}</p>
          </h4>
          <p className="modal-subHeader-text">{modalSubHeaderText}</p>
        </ModalHeader>

        <ModalBody className="chart-modal-body-container">
          <div className="bx--modal-content__text bx--modal-content__regular-content chart-modal-body">
            <BarCharts data={chartData} options={chartOptions} />
          </div>
        </ModalBody>
      </ComposedModal>
    </div>
  );
};
export default ChartModal;
